import apiClient from "./apiClient";

export const listAuditUniverse = (params = {}) => apiClient.get("/audit-universe", { params });
export const createAuditUniverse = (payload) => apiClient.post("/audit-universe", payload);
export const getAuditUniverse = (id) => apiClient.get(`/audit-universe/${id}`);
export const updateAuditUniverse = (id, payload) => apiClient.patch(`/audit-universe/${id}`, payload);
export const createAuditForUniverse = (id, payload) =>
  apiClient.post(`/audit-universe/${id}/audits`, payload);

export const listAudits = (params = {}) => apiClient.get("/audits", { params });
export const createAudit = (payload) => apiClient.post("/audits", payload);
export const getAudit = (id) => apiClient.get(`/audits/${id}`);
export const updateAudit = (id, payload, adminOverride = false) =>
  apiClient.patch(`/audits/${id}`, payload, { params: { admin_override: adminOverride } });
export const restoreAudit = (id, payload = {}) => apiClient.post(`/audits/${id}/restore`, payload);
export const updateAuditScope = (id, payload, adminOverride = false) =>
  apiClient.post(`/audits/${id}/scope`, payload, { params: { admin_override: adminOverride } });
export const transitionAuditStep = (id, targetStep, state, adminOverride = false) =>
  apiClient.post(`/audits/${id}/stepper`, null, {
    params: { target_step: targetStep, state, admin_override: adminOverride },
  });
export const updateAuditWorkflow = (id, payload, adminOverride = false) =>
  apiClient.post(`/audits/${id}/workflow`, payload, { params: { admin_override: adminOverride } });

export const listScopeDocuments = (auditId) => apiClient.get(`/audits/${auditId}/scope/documents`);
export const uploadScopeDocument = (auditId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return apiClient.post(`/audits/${auditId}/scope/documents`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const approveScopeDocument = (auditId, docId, reason) =>
  apiClient.post(`/audits/${auditId}/scope/documents/${docId}/approve`, { reason });
export const rejectScopeDocument = (auditId, docId, reason) =>
  apiClient.post(`/audits/${auditId}/scope/documents/${docId}/reject`, { reason });

export const listAuditHistory = (auditId) => apiClient.get(`/audits/${auditId}/history`);
export const createAuditFinding = (auditId, payload) =>
  apiClient.post(`/audits/${auditId}/findings`, payload);

export const uploadFinalReport = (auditId, file, distributionList = []) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("distribution_list", JSON.stringify(distributionList));
  return apiClient.post(`/audits/${auditId}/report/final`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const listAuditPlans = (params = {}) => apiClient.get("/audit-plans", { params });
export const createAuditPlan = (payload) => apiClient.post("/audit-plans", payload);
export const updateAuditPlan = (id, payload) => apiClient.patch(`/audit-plans/${id}`, payload);
export const approveAuditPlan = (id) => apiClient.post(`/audit-plans/${id}/approve`);
export const listAuditPlanItems = (planId, params = {}) => apiClient.get(`/audit-plans/${planId}/items`, { params });
export const createAuditPlanItem = (planId, payload) => apiClient.post(`/audit-plans/${planId}/items`, payload);
export const updateAuditPlanItem = (planId, itemId, payload) =>
  apiClient.patch(`/audit-plans/${planId}/items/${itemId}`, payload);
export const createEngagementFromPlanItem = (itemId, payload = {}) =>
  apiClient.post(`/audit-plan-items/${itemId}/engagements`, payload);

export const listTaxonomy = (category) => apiClient.get(`/taxonomy/${category}`);
